import React, { Component } from 'react';

import Form from "@sm/core/Form";

import { crudActions } from "@sm/services/crudActions";
import { DATA_TYPES } from "@modules/data/ManualInput";

class OtcSettlementComponent extends Component {
  state= {
    otcSettlementFormTotal: new Form(
      {
        availableBalance: "",
        requestedSettlement: "",
        balanceToSettle: "",
        propertyId: "",
      },
      [
        {
          name: "availableBalance",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "requestedSettlement",
          type: "isString",
          rules: {
            required: false,
          },
        },
        {
          name: "balanceToSettle",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "propertyId",
          type: "isString",
          rules: {
            required: true,
          },
        }
      ]
    ),
    otcSettlementBaseMidRowFields: [
      {
        name: "provider",
        label: "Provider",
        disabled: true,
        fieldType: "input",
        flexGrow: 0.35
      }, {
        name: "account",
        label: "Account",
        disabled: true,
        fieldType: "input",
        flexGrow: 0.35
      }, {
        name: "idTPlusX",
        label: "MID",
        disabled: true,
        fieldType: "input",
        flexGrow: 0.25
      }, {
        name: "name",
        label: "Tags",
        disabled: true,
        fieldType: "input",
        flexGrow: 0.35
      }, {
        name: "date",
        label: "Date",
        disabled: true,
        fieldType: "input",
        flexGrow: 0.2,
      }, {
        name: "withheldFunds",
        label: "Disputed Funds",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 0.25,
        hideColumn: false
      }, {
        name: "walletBalance",
        label: "Payout Wallet",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 0.3,
        hideColumn: false,
        rightAlign: true,
      },{
        name: "pendingPayouts",
        label: "Pending Payouts",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 0.25,
        hideColumn: false,
        rightAlign: true,
      }, {
        name: "availableBalance",
        label: "Available Balance",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 0.25,
        rightAlign: true,
      }, {
        name: "collectedFunds",
        label: "Collected Funds",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 0.25,
        rightAlign: true,
      },  {
        name: "balanceToSettle",
        label: "Balance to Settle",
        fieldType: "input",
        flexGrow: 0.25,
        updateRequestedField: true,
        rightAlign: true,
      }, {
        name: "checkBox",
        fieldType: "checkBox",
        autoMethod: (index) => this.props.onMidSelect(index, DATA_TYPES.OTC_SETTLEMENT),
        disabled: true,
        alignSelf: "end",
        flexGrow: "0"
      }
    ],
    otcSettlementBaseFields: [[
      {
        name: "currency",
        label: "MID Currency",
        disabled: true,
        fieldType: "input",
      },
      {
        name: "availableBalance",
        label: "Total Available Balance",
        fieldType: "input",
        formatValue: true,
        disabled: true,
        rightAlign: true,
      },
      {
        name: "requestedSettlement",
        label: "Available Balance Reduction",
        fieldType: "input",
        rightAlign: true,
      },
      {
        name: "balanceToSettle",
        label: "Balance to Exchange",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        rightAlign: true,
      },
      {
        name: "propertyId",
        label: "Status",
        fieldType: "select",
        getOptions: () => this.getOptionsFromState("statuses"),
        items: "statuses",
      },
    ],
    [
      { fieldType: "empty" }, { fieldType: "empty" },
      // {
      //   name: "checkBox",
      //   fieldType: "checkBox",
      //   label: "OTC",
      //   autoMethod: (index) => this.props.onAutoFunction(index),
      //   disabled: true,
      //   alignSelf: "end",
      //   flexGrow: "0.25",
      //   big: true
      // },
      {
        name: "notes",
        label: "Notes",
        fieldType: "textarea",
        flexGrow: 1
      },
      {
        fieldType: "button",
        buttonLabel: "Next"
      },
    ]],
    otcSettlementSecondBaseMidRowFields: [
      {
        name: "provider",
        label: "Provider",
        disabled: true,
        fieldType: "input",
        flexGrow: 0.35
      }, {
        name: "account",
        label: "Account",
        disabled: true,
        fieldType: "input",
        flexGrow: 0.35
      }, {
        name: "collectedFunds",
        label: "Collected Funds",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 0.35,
        rightAlign: true,
      }, {
        name: "fxPair",
        label: "FX Pair",
        flexGrow: 0.25,
        fieldType: "select",
        disabled: true,
        getOptions: () => this.state.getOptionsFromParentState("fxPairs"),
        items: "fxPairs"
      }, {
        name: "fxWeightedAvg",
        label: "Inbound FX",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 0.25,
        rightAlign: true,
      }, {
        name: "priorFxRate",
        label: "Prior FX Rate",
        disabled: true,
        fieldType: "input",
        flexGrow: 0.25,
        rightAlign: true,
      }, {
        name: "amount",
        label: "Amount",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 0.25,
        rightAlign: true,
      }, {
        name: "fxRate",
        label: "FX Rate",
        fieldType: "input",
        flexGrow: 0.25,
        rightAlign: true,
      }
    ],
    otcSettlementSecondBaseFields: [
      {
        name: "currency",
        label: "Currency",
        disabled: true,
        fieldType: "input",
        flexGrow: 2
      },
      {
        name: "otcCalculated",
        label: "OTC Calculated",
        fieldType: "input",
        formatValue: true,
        disabled: true,
        flexGrow: 4,
        rightAlign: true
      },
      {
        name: "settlementFee",
        label: "Settlement Fee",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 4,
        rightAlign: true
      },
      {
        name: "otcSettlement",
        label: "OTC Settlement",
        disabled: true,
        fieldType: "input",
        formatValue: true,
        flexGrow: 4,
        rightAlign: true
      },
      {
        name: "confirmationLink",
        label: "Validation Link",
        fieldType: "input",
        flexGrow: 8,
      },
      { fieldType: "empty" }, { fieldType: "empty" }, { fieldType: "empty" },
      {
        fieldType: "button",
        flexGrow: 8,
        buttonLabel: "Submit",
        buttonAction: () => this.submitOtcSettlement()
      },
    ],
    otcSettlementSecondFormTotal: new Form(
      {
        currency: "",
        otcCalculated: "",
        settlementFee: "",
        otcSettlement: "",
        confirmationLink: "",
      },
      [
        {
          name: "currency",
          type: "isString",
          rules: {
            required: false,
          },
        },
        {
          name: "otcCalculated",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "settlementFee",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "otcSettlement",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "confirmationLink",
          type: "isUrl",
          rules: {
            required: true,
          },
        }
      ]
    ),
  };

  componentDidMount() {
    const { getOptionsFromState, statuses } = this.props;
    if (getOptionsFromState) {
      this.setState({
        getOptionsFromParentState: getOptionsFromState,
        statuses: statuses
      });
    }
  };

  componentDidUpdate(oldProps) {
    const newProps = this.props;
    if (oldProps.statuses.length !== newProps.statuses.length) {
      this.setState({
        statuses: newProps.statuses,
      });
    }
  }

  populateSettlementByAmountForm = (controls, responseMids) => {
    const { otcSettlementBaseMidRowFields, otcSettlementBaseFields, otcSettlementFormTotal } = this.state;
    const otcSettlementBaseMidRowFieldsCopy = otcSettlementBaseMidRowFields.map(field => ({ ...field }));
    const otcSettlementBaseFieldsCopy = otcSettlementBaseFields
      .map(fields => ([ ...fields.map(field => ({ ...field }))]));
    let OTC_SETTLEMENT = [];
    const settlementFormByAmount = [];
    const stateForUpdate = {};

    let availableBalance = 0;
    responseMids.forEach((midInfo) => {
      const midForm = this.getMidRowSettlementByAmountForm(midInfo);
      if (midForm.payoutWalletType !== "") {
        this.addPostValue(midForm, "walletBalance", midForm.payoutWalletType);
      }
      settlementFormByAmount.push(midForm);
      OTC_SETTLEMENT.push(otcSettlementBaseMidRowFieldsCopy);
      availableBalance += parseFloat(midInfo.availableBalance);
    });

    const notesForm = new Form({
      notes: "",
      withOtc: false
    }, [{
      name: "notes",
      type: "isString",
      rules: {
        required: false,
      },
    }]);
    Object.assign(otcSettlementFormTotal, {
      availableBalance: parseFloat((availableBalance).toFixed(2)) || 0,
      propertyId: "33",
      currency: controls.currency || "",
      requestedSettlement: "",
      balanceToSettle: 0
    });
    Object.assign(stateForUpdate, {
      otcSettlementFormTotal: otcSettlementFormTotal,
      otcSettlementFormMids: [...settlementFormByAmount],
      settlementMids: [...settlementFormByAmount]
    });

    OTC_SETTLEMENT.push([]);
    OTC_SETTLEMENT = OTC_SETTLEMENT.concat(otcSettlementBaseFieldsCopy);
    this.updateField(DATA_TYPES.OTC_SETTLEMENT, OTC_SETTLEMENT);
    settlementFormByAmount.push(new Form(), otcSettlementFormTotal, notesForm);
    Object.assign(stateForUpdate, {
      otcSettlementForm: settlementFormByAmount
    });
    return stateForUpdate;
  };

  addPostValue = (form, fieldName, value) => {
    form[fieldName + "PostValue"] = (
      <span className={ `txValue-inputMask ${value === "N/A" ? 'full-width' : ''}` }>({value})</span>
    );
  };
  getMidRowSettlementByAmountForm = (midInfo) => {
    const { getTXValue } = this.props;
    return new Form(
      {
        id: midInfo.id,
        idTPlusX: `${midInfo.id} (T+${getTXValue(midInfo.id)})`,
        name: midInfo.name,
        method: midInfo.method,
        account: midInfo.pspAccount,
        pspAccountId: midInfo.pspAccountId,
        provider: midInfo.providerName,
        date: midInfo.date,
        pendingPayouts: parseFloat(midInfo.pendingPayouts) || 0,
        availableBalance: midInfo.availableBalance ? parseFloat(midInfo.availableBalance) : 0,
        collectedFunds: midInfo.collectedFunds ? parseFloat(midInfo.collectedFunds) : 0,
        walletBalance: midInfo.walletBalance || 0,
        payoutWalletType: midInfo.payoutWalletType || "",
        balanceToSettle: 0,
        providerName: midInfo.providerName || '',
        withheldFunds: midInfo.withheldFunds || 0,
        disabled: false,
        isChecked: false
      },
      [
        {
          name: "id",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "name",
          type: "isString",
          rules: {
            required: false,
          },
        },
        {
          name: "account",
          type: "isString",
          rules: {
            required: false,
          },
        },
        {
          name: "provider",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "date",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "pendingPayouts",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "availableBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "collectedFunds",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "walletBalance",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "payoutWalletType",
          type: "isString",
          /*          rules: {
            required: true,
          },*/
        },
        {
          name: "balanceToSettle",
          type: "isNumber",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "withheldFunds",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "disabled",
          type: "isBoolean",
          rules: {
            required: true,
          },
        },
        {
          name: "isChecked",
          type: "isBoolean",
          rules: {
            required: true,
          }
        }
      ]
    );
  };

  onChangeFilter = () => {
    const { controls } = this.props;
    const { otcSettlementBaseMidRowFields } = this.state;

    const isFormValid = controls.isFormValid();
    this.onChangeValidationUpdate(controls, isFormValid);

    if (isFormValid) {
      const { merchant, midIds } = controls;

      const url = `v1/data/input?clientId=${ merchant }&dataInputTypes=SETTLEMENT_BY_AMOUNT&&midIds=${ midIds }`;

      crudActions.get(url)
        .then((response) => {
          // temp remove - to display all MIDs, not only with available balance and collected funds > 0
          // response = response.filter(row => row.availableBalance > 0 && row.collectedFunds > 0);
          if (response.length) {
            // Do not display column if value in each row === 0
            const disputedFundsField = otcSettlementBaseMidRowFields.find(field => field.name === "withheldFunds");
            disputedFundsField.hideColumn = !response.some(row => row.withheldFunds !== 0);
            const payoutWalletField = otcSettlementBaseMidRowFields.find(field => field.name === "walletBalance");
            payoutWalletField.hideColumn = !response.some(row => row.walletBalance !== 0);
            const pendingPayoutsField = otcSettlementBaseMidRowFields.find(field => field.name === "pendingPayouts");
            pendingPayoutsField.hideColumn = !response.some(row => row.pendingPayouts !== 0);

            const newState =  this.populateSettlementByAmountForm(controls, response);
            Object.assign(newState, {
              showSecondPanel: true,
              showThirdPanel: false,
              loadingDataInput: false,
              lockButton: false,
            });
            this.updateState(newState, otcSettlementBaseMidRowFields);
          } else {
            this.errorUpdate("OTC locked - inbound settlement missing.");
          }
        })
        .catch((err) => {
          this.errorUpdate(err ? err.message : "");
        });
    }
  };

  onSaveDataEntries = () => {
    const { form, formTotal, settlementMids, savedData } = this.props;

    const isSettlementFormValid = form.map(elem => elem.isFormValid()).every(Boolean);
    this.saveValidationUpdate(form, isSettlementFormValid, isSettlementFormValid && formTotal.balanceToSettle > 0, true);

    if (isSettlementFormValid) {
      if (formTotal.balanceToSettle > 0) {
        const midWithAmount = settlementMids.filter(m => parseFloat(m.balanceToSettle) > 0);
        const midIds = midWithAmount.map((mid) => mid.id);
        const url = `v1/otc/settlement?clientId=${ savedData.merchant }&fxPair=${ savedData.fxPair }&midIds=${ midIds }`;
        crudActions.get(url)
          .then((response) => {
            const firstPanelLength = form.length;
            const newState =  this.populateOTCSettlementForm(response, midWithAmount);
            Object.assign(newState, {
              showThirdPanel: true,
              loadingDataInput: false,
              lockButton: false,
              firstPanelLength: firstPanelLength
            });
            this.updateState(newState);
          })
          .catch((err) => {
            this.errorUpdate(err?.message);
          });
      } else {
        this.errorUpdate('Balance to Settle value should be greater than 0! Please, select at least one MID to proceed.');
      }
    }
  };

  populateOTCSettlementForm = (response, midWithAmount) => {
    const { form, fields, savedData } = this.props;
    const { otcSettlementSecondBaseMidRowFields, otcSettlementSecondFormTotal } = this.state;
    let { otcSettlementSecondBaseFields } = this.state;
    const stateForUpdate = {};
    const propertyId =  form[form.length - 2].propertyId;

    const accountWithAmount = new Map();

    midWithAmount.forEach(item => {
      const id = item.pspAccountId;
      if (!accountWithAmount.has(id)) {
        accountWithAmount.set(id, { ...item });
      } else {
        const existing = accountWithAmount.get(id);
        existing.balanceToSettle += item.balanceToSettle;
        accountWithAmount.set(id, existing);
      }
    });
    const mergedMids = response.map(resItem => ({
      ...resItem,
      ...accountWithAmount.get(resItem.pspAccountId)
    }));
    fields.forEach(fieldRow => fieldRow.forEach(elem => elem.disabled = true));
    form.forEach(formRow => formRow.disabled = true);

    const otcMids = [];
    let otcCalculated = 0;
    mergedMids.forEach((midInfo) => {
      const midForm = this.getMidRowOtcSettlementForm(midInfo);
      const amount = parseFloat(midForm.amount);
      const fxRate = parseFloat(midForm.fxRate);
      if (!isNaN(amount) && !isNaN(fxRate) && fxRate !== 0) {
        otcCalculated = otcCalculated + amount / fxRate;
      }
      otcMids.push(midForm);
      fields.push(otcSettlementSecondBaseMidRowFields);
    });
    form.push(...otcMids);
    form.push(new Form());
    fields.push([]);
    if (propertyId === "33") {
      otcSettlementSecondBaseFields = otcSettlementSecondBaseFields.filter(elem => elem.name !== "confirmationLink");
    }
    const confirmationLinkField = otcSettlementSecondFormTotal.fieldRules.find(
      (fieldRule) => fieldRule.name === "confirmationLink"
    );
    confirmationLinkField.rules.required = propertyId !== "33";

    fields.push(otcSettlementSecondBaseFields);
    otcSettlementSecondFormTotal.currency = savedData.fxPair.split("/")[0];
    otcSettlementSecondFormTotal.otcCalculated = otcCalculated;
    otcSettlementSecondFormTotal.settlementFeeValue = this.getSettlementFee();
    otcSettlementSecondFormTotal.settlementFee = otcSettlementSecondFormTotal.otcCalculated * (otcSettlementSecondFormTotal.settlementFeeValue / 100);
    otcSettlementSecondFormTotal.otcSettlement = otcSettlementSecondFormTotal.otcCalculated - otcSettlementSecondFormTotal.settlementFee;

    form.push(otcSettlementSecondFormTotal);

    Object.assign(stateForUpdate, {
      otcSettlementForm: form,
      otcMids: otcMids
    });
    this.updateField(DATA_TYPES.OTC_SETTLEMENT, fields);

    return stateForUpdate;
  };

  getMidRowOtcSettlementForm = (midInfo) => {
    const { savedData } = this.props;
    return new Form(
      {
        provider: midInfo.providerName,
        account: midInfo.pspAccountName,
        pspAccountId: midInfo.pspAccountId,
        collectedFunds: midInfo.collectedFunds || 0,
        fxPair: savedData.fxPair || "",
        fxWeightedAvg: Number(Number(midInfo.fxAvgRate).toFixed(2)) || 0,
        priorFxRate: midInfo.fxPriorRate || 0,
        amount: midInfo.balanceToSettle,
        fxRate: midInfo.fxRate || this.getFxRateDraft(midInfo.fxAvgRate),
      },
      [
        {
          name: "provider",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "account",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "collectedFunds",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "fxPair",
          type: "isString",
          rules: {
            required: true,
          },
        },
        {
          name: "fxWeightedAvg",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "priorFxRate",
          type: "isNumber",
          rules: {
            required: true,
          },
        },
        {
          name: "amount",
          rules: {
            min: 0,
            required: true,
          },
        },
        {
          name: "fxRate",
          type: "isString",
          rules: {
            required: true,
          },
        }
      ]
    );
  };

  getFxRateDraft = (fxAvgRate) => {
    const markUp = this.getMarkUp();
    return (fxAvgRate + markUp).toFixed(2);
  };

  getMarkUp = () => {
    return this.getFeeValue("markUp");
  };

  getSettlementFee = () => {
    return this.getFeeValue("settlementFee");
  };

  getFeeValue = (field) => {
    const { savedData } = this.props;
    const settlementFeeData = this.state.getOptionsFromParentState("settlementFeeData");
    const currencySettlementFee = settlementFeeData.find(fee => fee.currency === savedData.currency);
    return currencySettlementFee[field];
  };

  submitOtcSettlement = () => {
    const { savedData, form, formTotal, settlementMids } = this.props;

    const isSettlementFormValid = form.map(elem => elem.isFormValid()).every(Boolean);
    this.saveValidationUpdate(form, isSettlementFormValid, isSettlementFormValid, true);

    const otcMids = this.state.getOptionsFromParentState("otcMids");

    // fxRate vs fxWeightedAvg values manual validation
    if (otcMids?.length) {
      let isFxRateValid = true;
      otcMids.map(currentForm => {
        const isValid = currentForm.fxWeightedAvg ?
          currentForm.fxRate >= currentForm.fxWeightedAvg
          :
          currentForm.fxRate > 0;
        if (!isValid) {
          isFxRateValid = false;
          currentForm.errors.errors = {
            ...currentForm.errors.errors,
            fxRate: ""
          };
        }
        return currentForm;
      });
      
      if (!isFxRateValid) {
        this.updateState(otcMids);
        this.errorUpdate('FX Rate value should not be less than Inbound FX value. Please check before proceed.');
        return;
      }
    }

    const notes = form[form.length - otcMids.length - 3].notes;

    if (isSettlementFormValid) {
      const settlementByAmountDTOS = settlementMids.filter(m => parseFloat(m.balanceToSettle) > 0).map((mid) => {
        return {
          id: mid.id,
          name: mid.name,
          account: mid.account,
          walletBalance: mid.walletBalance,
          pendingPayouts: mid.pendingPayouts,
          availableBalance: mid.availableBalance,
          balanceToSettle: mid.balanceToSettle,
          currency: formTotal.currency,
          date: mid.date,
          midId: mid.id,
          notes: notes,
          clientId: savedData.merchant,
          propertyId: formTotal.propertyId,
        };
      });

      const otcSettlementByAmountDTOS = otcMids.map((mid) => {
        return {
          midId: mid.id,
          pspAccountId: mid.pspAccountId,
          amount: mid.amount,
          fxRate: mid.fxRate
        };
      });

      const otcTotal = form[form.length - 1];

      const data = {
        settlements: settlementByAmountDTOS,
        otcSettlements: otcSettlementByAmountDTOS,
        currency: otcTotal.currency,
        otcCalculated: otcTotal.otcCalculated,
        settlementFee: otcTotal.settlementFee,
        otcSettlement: otcTotal.otcSettlement,
        // Add Validation Link for "Settled" status only
        ...(formTotal.propertyId !== "33" && { validationLink: otcTotal.confirmationLink }),
        fxPair: savedData.fxPair,
        fxRate: savedData.fxRate
      };
      crudActions.post(`v1/otc/settlement`, data)
        .then(() => {
          this.afterSuccessSave();
        })
        .catch((err) => {
          this.errorUpdate(err?.message);
        });
    }

  };

  getOptionsFromState = (optionsName) => {
    return this.state[optionsName];
  };

  updateField = (name, value) => {
    this.props.updateField(name, value);
  };

  updateState = (stateForUpdate) => {
    this.props.updateState(stateForUpdate);
  };

  onChangeValidationUpdate = (controls, isFormValid) => {
    this.props.updateStateAfterOnChangeValidation(controls, isFormValid);
  };

  saveValidationUpdate = (form, isFormValid, allValid) => {
    this.props.updateStateAfterOnSaveValidation(form, isFormValid, allValid);
  };

  afterSuccessSave = () => {
    this.props.updateStateAfterSuccessSave("Settlement successfully initiated.");
  };

  errorUpdate = (message) => {
    this.props.showErrorAlert(message);
  };

  render() {
    return <></>;
  };
}

export default OtcSettlementComponent;